module.exports = __webpack_public_path__ + "img/telegram.d953f840.png";